import { Component, inject } from '@angular/core';
import {
  NumberInputComponent,
  TextInputComponent,
} from '@navstation-portal/shared/ui/components';
import { FormsModule } from '@angular/forms';
import { injectDispatch } from '@ngrx/signals/events';
import { IsVisibleDirective } from '@navstation-portal/shared/ui/directives';
import {
  AbstractStoreConnectedSectionComponent,
  offshoreOperationalEvents,
  OffshoreOperationalFormStore,
  OffshoreReportStore,
} from '@navstation-portal/reporting/data-access/offshore-report';

@Component({
  selector: 're-vessel-details',
  standalone: true,
  templateUrl: './vessel-details.component.html',
  imports: [
    FormsModule,
    NumberInputComponent,
    TextInputComponent,
    IsVisibleDirective,
  ],
})
export class VesselDetailsComponent extends AbstractStoreConnectedSectionComponent {
  tabId = 'operational';
  sectionId = 'vesselDetails';
  events = injectDispatch(offshoreOperationalEvents);
  store = inject(OffshoreOperationalFormStore);
  offshoreStore = inject(OffshoreReportStore);
}
